export function toPublicServiceListingItem(service) {
    const duration = Number(service.duration);
    return {
        id: Number(service.id),
        name: String(service.name ?? ""),
        ...(service.provider?.name
            ? { providerName: String(service.provider.name) }
            : {}),
        ...(service.category?.name
            ? { categoryName: String(service.category.name) }
            : {}),
        ...(service.service_type?.name
            ? { serviceTypeName: String(service.service_type.name) }
            : {}),
        ...(Number.isFinite(duration) && duration > 0
            ? { durationLabel: `${duration} min` }
            : {}),
        ...((service.photoUrls?.[0] ?? service.photo_urls?.[0])
            ? { photoUrl: String(service.photoUrls?.[0] ?? service.photo_urls[0]) }
            : {}),
        ...(service.description
            ? { additionalInformation: String(service.description) }
            : service.additional_information
                ? { additionalInformation: String(service.additional_information) }
                : {}),
        averageRating: service.averageRating != null ? Number(service.averageRating) : null,
        reviewCount: Number(service.reviewCount ?? 0),
    };
}
